<div class="filterbar__container">
  <div class="flex end">
    <a
      (click)="filterBarClose.emit()"
      class="filterbar-close__icon">
      <mat-icon svgIcon="close-dark"></mat-icon>
    </a>
  </div>
  <div class="filterbar__content">
    <filter-category
      *ngIf="modelCategory?.options?.length > 0"
      [category]="modelCategory"
      (categoryChange)="onFilterBarChange($event)">
    </filter-category>
    <filter-category
      *ngIf="subtypeCategory?.options?.length > 0"
      [category]="subtypeCategory"
      (categoryChange)="onFilterBarChange($event)">
    </filter-category>
    <filter-category
      *ngIf="locationCategory?.options?.length > 0"
      [category]="locationCategory"
      (categoryChange)="onFilterBarChange($event)">
    </filter-category>
    <filter-category
      *ngIf="statusCategory?.options?.length > 0"
      [category]="statusCategory"
      (categoryChange)="onFilterBarChange($event)">
    </filter-category>
    <filter-category
      *ngIf="activeCategory?.options?.length > 0"
      [category]="activeCategory"
      (categoryChange)="onIsActiveFilterChange($event)">
    </filter-category>
    <filter-category
      *ngIf="contractCategory?.options?.length > 0"
      [category]="contractCategory"
      (categoryChange)="onFilterBarChange($event)">
    </filter-category>
    <filter-category
      *ngIf="manufacturerCategory?.options?.length > 0"
      [category]="manufacturerCategory"
      (categoryChange)="onFilterBarChange($event)">
    </filter-category>
    <div
      class="col u-scroll-vertical"
      style="max-height: 100vh">
      <div
        id="service-range-filter"
        class="filterbar__item">
        <div class="range-filter__title">
          {{ "toolfilters.serviceduein" | translate }}
        </div>
        <div class="range-filter__description">
          {{ filter.serviceDueMonths }} {{ "toolfilters.month" | translate }}
        </div>
        <div class="range-filter__slider">
          <mat-slider
            id="service-slider"
            name="service-slider"
            min="0"
            max="6"
            step="1">
            <input
              matSliderThumb
              [(ngModel)]="filter.serviceDueMonths"
              (dragEnd)="onServiceDueChange($event)" />
          </mat-slider>
        </div>
      </div>
      <div
        id="calibration-range-filter"
        class="filterbar__item">
        <div class="range-filter__title">
          {{ "toolfilters.calibrationduein" | translate }}
        </div>
        <div class="range-filter__description">
          {{ filter.calibrationDueMonths }} {{ "toolfilters.month" | translate }}
        </div>
        <div class="range-filter__slider">
          <mat-slider
            id="calibration-slider"
            name="calibration-slider"
            min="0"
            max="6"
            step="1">
            <input
              matSliderThumb
              [(ngModel)]="filter.calibrationDueMonths"
              (dragEnd)="onCalibrationDueChange($event)" />
          </mat-slider>
        </div>
      </div>

      <!-- TODO: Add LastServiceIn and LastCalibrationIn filters also on API -->
    </div>
  </div>

  <div class="filterbar__actions">
    <button
      (click)="onClearAll()"
      class="button--sm button-secondary button-block">
      Clear All
    </button>
    <button
      (click)="onApplyFilter()"
      class="button--sm button-primary button-block">
      Apply
    </button>
  </div>
</div>
